<template>
  <div class="searchable-select">
    <h3 v-if="title">{{ title }}</h3>

    <!-- Display area -->
    <div class="select-display" @click="toggleDropdown" ref="displayEl">
      <span style="user-select: none">{{ selectedValue ? selectedValue.label : "Selecione uma opção" }}</span>
    </div>

    <!-- Dropdown-->
    <teleport to="body">
      <div v-if="dropdownOpen" class="dropdown" :style="dropdownStyles">
        <input type="text" v-model="searchQuery" placeholder="Pesquisar..." />

        <ul>
          <li @click="selectOption(null)" style="color: #0000008a">Limpar</li>
          <li v-for="item in filteredOptions" :key="item.id" @click="selectOption(item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    options: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((option) => "label" in option);
      },
    },
    modelValue: [String, Number, Date, Array, Object],
    onSelect: { type: Function, default: null },
  },
  data() {
    return {
      dropdownOpen: false,
      searchQuery: "",
      dropdownStyles: {},
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
        if (this.onSelect) {
          this.onSelect(value);
        }
      },
    },
    filteredOptions() {
      const query = this.searchQuery.toLowerCase();
      return this.options.filter((opt) => opt.label.toLowerCase().includes(query));
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      this.searchQuery = "";
      if (this.dropdownOpen) {
        this.$nextTick(() => {
          this.updateDropdownPosition();
        });
      }
    },
    selectOption(item) {
      this.selectedValue = item;
      this.dropdownOpen = false;
    },
    updateDropdownPosition() {
      const el = this.$refs.displayEl;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      this.dropdownStyles = {
        position: "absolute",
        top: `${rect.bottom + window.scrollY}px`,
        left: `${rect.left + window.scrollX}px`,
        width: `${rect.width}px`,
        zIndex: 9999,
      };
    },
  },
};
</script>

<style scoped src="../style.css"></style>
